import { render, staticRenderFns } from "./LivesVideoOrder.vue?vue&type=template&id=a2f7b114&scoped=true&"
import script from "./LivesVideoOrder.vue?vue&type=script&lang=js&"
export * from "./LivesVideoOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f7b114",
  null
  
)

export default component.exports